import { CircularProgress, Box } from '@mui/material';
import React, { Suspense } from 'react';

import { BarcodeScannerProps } from './BarcodeScanner.props';
import {
  VideoContainer,
  VideoElement,
  ViewfinderOverlay,
  ViewfinderFrame,
  ViewfinderBottomLeft,
  ViewfinderBottomRight,
  ScanLine,
  HintText,
  ErrorContainer,
} from './BarcodeScanner.styles';
import { useBarcodeScanner } from './useBarcodeScanner';

const ZxingScanner = React.lazy(() => import('./ZxingScanner'));

const NativeScanner: React.FC<BarcodeScannerProps> = ({ onDetect }) => {
  const { videoRef, error } = useBarcodeScanner(onDetect);

  if (error) {
    return <ErrorContainer>{error}</ErrorContainer>;
  }

  return (
    <VideoContainer>
      <VideoElement ref={videoRef} playsInline muted aria-label="Barcode scanner camera feed" />
      <ViewfinderOverlay aria-hidden="true">
        <ViewfinderFrame>
          <ScanLine />
          <ViewfinderBottomLeft />
          <ViewfinderBottomRight />
        </ViewfinderFrame>
      </ViewfinderOverlay>
      <HintText>Point camera at serial number barcode</HintText>
    </VideoContainer>
  );
};

export const BarcodeScanner: React.FC<BarcodeScannerProps> = ({ onDetect }) => {
  const hasNativeSupport = 'BarcodeDetector' in window;

  if (hasNativeSupport) {
    return <NativeScanner onDetect={onDetect} />;
  }

  return (
    <Suspense
      fallback={
        <Box display="flex" justifyContent="center" alignItems="center" p={4}>
          <CircularProgress size={32} />
        </Box>
      }
    >
      <ZxingScanner onDetect={onDetect} />
    </Suspense>
  );
};
